export default {
  lib: 'https://acdn.adnxs.com/ast/ast.js',
  pageOpts: {
    member: 9943,
    disablePsa: true,
    noBidIfUnsold: true,
    keywords: {},
  },
};
